import { render } from "./App.vue?vue&type=template&id=27d90f4f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=27d90f4f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3625838732/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d90f4f"]])

export default __exports__